/** Number, rate and duration formatting shared by the Insights screen and its module panels. */

export const fmtNumber = (n) => (n || 0).toLocaleString();

export const fmtDecimal = (n, digits = 1) =>
  n == null ? '—' : n.toLocaleString(undefined, { maximumFractionDigits: digits });

export const fmtRate = (rate) =>
  rate == null
    ? '—'
    : rate.toLocaleString(undefined, { style: 'percent', maximumFractionDigits: 1 });

export const fmtDuration = (sec, t) => {
  if (sec == null) return '—';

  const total = Math.round(sec);
  const h = Math.floor(total / 3600);
  const m = Math.floor((total % 3600) / 60);
  const s = total % 60;

  if (h) return t('admin.insights.fanchatTopics.duration.hours', { h, m });
  if (m) return t('admin.insights.fanchatTopics.duration.minutes', { m, s });
  return t('admin.insights.fanchatTopics.duration.seconds', { s });
};
